__turbopack_context__.v({
  "content": "Carfax-module-scss-module__Tf45xW__content",
  "fade-in": "Carfax-module-scss-module__Tf45xW__fade-in",
  "logo": "Carfax-module-scss-module__Tf45xW__logo",
  "no-transform": "Carfax-module-scss-module__Tf45xW__no-transform",
  "rotate": "Carfax-module-scss-module__Tf45xW__rotate",
});
